import { endsWith } from "lodash";
import Env from "../utils/env";

export enum ProductLogo {
	url = "url",
}

export enum ProductDescriptions {
	short = "short",
	long = "long",
}

export enum ProductFeature {
	title = "title",
	description = "description",
}

export enum ProductLegalDetailEnums {
	description = "description",
	licenseAgreementUrl = "license_agreement_url",
	privacyPolicyUrl = "privacy_policy_url",
}

export enum ProductSupportEnums {
	description = "description",
	url = "url",
	phoneNumber = "phone_number",
	emailAddress = "email_address",
}

export enum ProductFAQs {
	question = "question",
	answer = "answer",
}

export enum ProductLinkedResources {
	type = "type",
	category = "category",
	title = "title",
	description = "description",
	url = "url",
	thumbnailUrl = "thumbnail_url",
}

export enum ProductQuickStartConfig {
	instructions = "instructions",
	defaultDeployInstructions = "default_deploy_instructions",
}

export const ProductKeys = {
	id: "_id",
	type: "type",
	productName: "name",
	productLogo: "logo",
	lastUpdateDate: "last_update_date",
	contacts: "contacts",
	isPublished: "published",
	creationDate: "creation_date",
	searchAliases: "search_aliases",
	logo: "logo",
	descriptions: "descriptions",
	legal: "legal",
	support: "support",
	features: "features",
	faqs: "faqs",
	linkedResources: "linked_resources",
	metaKeywords: "meta_keywords",
	categories: "categories",
	functionalCategories: "functional_categories",
	repositories: "repositories",
	quickStartConfig: "quick_start_configuration",
	certProjects: "cert_projects",
	drupalcompanyID: "drupal_company_id",
	orgID: "org_id",
	deleted: "deleted",
	eligibleForVendorValidation: "eligible_for_vendor_validation",
	certificationLevel: "certification_level",
	deployedAs: "deployed_as_all",
	targetPlatforms: "target_platforms",
} as const;

export const TabNames = {
	general: { name: "General", route: `${Env.productInformationPath}/general` },
	features: { name: "Features & Benefits", route: `${Env.productInformationPath}/features` },
	quickStart: { name: "Quick start & Config", route: `${Env.productInformationPath}/quick-start` },
	linkedResources: { name: "Linked Resources", route: `${Env.productInformationPath}/linked-resources` },
	faq: { name: "FAQs", route: `${Env.productInformationPath}/faq` },
	support: { name: "Support", route: `${Env.productInformationPath}/support` },
	contacts: { name: "Contacts", route: `${Env.productInformationPath}/contacts` },
	legal: { name: "Legal", route: `${Env.productInformationPath}/legal` },
	seo: { name: "SEO", route: `${Env.productInformationPath}/seo` },
	versionMatrix: { name: "Version Matrix", route: `${Env.productInformationPath}/version-matrix` },
};

export const ProductListingTypes = {
	ContainerStack: "container stack",
	TraditionalApplication: "traditional application",
	OpenStackInfrastructure: "openstack infrastructure",
};

const removeTrailingSlash = (str: string): string => {
	if (endsWith(str, "\\")) {
		str = str.substring(0, str.length - 2);
		return removeTrailingSlash(str);
	}
	return str;
};

export const escapePyxisSpecialChars = (searchKey: string) => {
	return removeTrailingSlash(searchKey.replace(/[\\]/g, `\\\\`).replace(/[']/g, `\\'`));
};

export const ProductCreateTypesLabel = {
	standaloneApplication: "Standalone Application",
	containerized: "Containerized Application",
	openStackInfrastructure: "OpenStack Infrastructure",
};

export enum EPartnerValidationProgress {
	None = "none",
	Started = "started",
	Validated = "validated",
}

export enum EWorkloadType {
	Virt = "virt",
	CNF = "cnf",
	General = "general",
}

export const OpenShiftFullName = "Red Hat OpenShift Container Platform";
export const RHELFullName = "Red Hat Enterprise Linux";

export const ProductVersionKeys = {
	id: "_id",
	creationDate: "creation_date",
	lastUpdateDate: "last_update_date",
	orgID: "org_id",
	productListing: "product_listing",
	productVersion: "product_version",
	redHatAffinity: "redhat_affinity",
} as const;

export const CreateProductVersionModalKeys = {
	productVersion: ProductVersionKeys.productVersion,
	selectedVersions: "selectedVersions",
	openShiftProductData: "openShiftProductData",
	RhelProductData: "RhelProductData",
} as const;
